import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TerminalService } from '../../services/terminal.service';
import { MerchantService } from '../../services/merchant.service';
import { promise } from 'protractor';
import { first, takeUntil } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { TerminalSignUpViewModel } from '../../models/terminal-signup-view-model';
import { UserDataStoreService } from '../../services/user-data-store.service';
import { AuthenticationService } from '../../services/authentication.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ToastrService } from 'ngx-toastr';
import { Observable, timer } from 'rxjs';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ParticipantService } from '../../services/participant.service';
import { DeviceMakeViewModel } from '../../models/device-make-view-model';
import { DeviceModelViewModel } from '../../models/device-model-view-model';
import { TerminalContactsViewModel } from '../../models/terminal-contacts-view-model';
import { MerchantSignedUpViewModel } from '../../models/merchants-sign-up-view-model';
import { TerminalBulkOrderViewModel } from '../../models/termina-bulk-order-view-model';
import { MerchantDetailModel } from '../../models/merchant-detail-model';
import { TmCardAcceptorConfigViewModel } from '../../models/tm-card-acceptor-model';
import { DecodedNameLocation } from '../../models/decoded-name-location -view-model';
import { DatePipe } from '@angular/common';
import { ParticipantViewComponent } from '../../participant-management/participant-view/participant-view.component';
import { ParticipantViewModel } from '../../models/participant-view-model';
import { debug } from 'util';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Select2OptionData } from "ng-select2";
import { ContactDetailsViewModel } from '../../models/contact-details-view-model';
import { AccessPolicyEnum, PermissionEnum } from "../../services/guards/permissions";
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { param } from 'jquery';



@Component({
  selector: 'app-delivery-note',
  templateUrl: './delivery-note.component.html',
  styleUrls: ['./delivery-note.component.scss']
})
export class DeliveryNoteComponent implements OnInit {

  public deviceCheckList: Select2OptionData[] = [
    { id: "Yes", text: 'Yes' },
    { id: "No", text: 'No' }
  ];
  devicePowerSupply
  raiseDanger: boolean;
  success: boolean;
  Waybill: string;
  CustomerName: string;
  MerchantName: string;
  CreatedDate: string;
  TicketNo: string;
  MerchantNumber: string;
  merchantId: string;
  merchantNumberId: string;
  terminalId: string;
  ContactDetails: string;
  TerminalID: string;
  DeliveryAddress: string;
  SerialNumber: string;
  Make: string;
  Model: string;
  Country: string;
  Region: string;
  City: string;
  Town: string;
  battery: string;
  PowerSupply: string;
  SoftwareVersion: string;
  AppName: string;
  Keys: string;
  ParameterDownload: string;
  Battery: string;
  DriverName: string;
  CustomerDate: string;
  DriverDate: string;
  id: string;
  type: string;
  public terminals: TerminalSignUpViewModel[] = null;
  public terminal: TerminalSignUpViewModel;

  public terminalMakeList: DeviceMakeViewModel[];
  public terminalModelList: DeviceModelViewModel[];
  public terminalBulkOrderList: TerminalBulkOrderViewModel[];
  public contactDetails: TerminalContactsViewModel;
  public terminalsSignUp: TerminalSignUpViewModel[] = [];
  public terminalSignUp: TerminalSignUpViewModel;
  public merchantSignUp: MerchantSignedUpViewModel;
  public bulk: boolean;
  private _destroyed$ = new Subject<any>();
  public terminalContacts: TerminalContactsViewModel;
  public merchantContacts: ContactDetailsViewModel;
  public merchantDetails: MerchantDetailModel;
  public tmCardAcceptor: TmCardAcceptorConfigViewModel;
  public participant: ParticipantViewModel;
  public printContents: any;
  fcTicketNr: string;
  fcAppName: any;
  fcSoftwareVersion: any;
  fcPowerSupply: any;
  fcKeys: any;
  fcParameterDownload: any;
  fcBattery: any;
  public popupWin: any;
  public select2options: any = {
    multiple: false,
    width: '100%',
    allowClear: true
  };
  DeliveryMethod: string;
  byteArrayBarCode: Uint8Array;
  byteArrayQRCode: Uint8Array;
  UserPhoto: string;
  qrCodeImageURL: string;
  qrCodeImage1URL: SafeUrl;
  isCourier: boolean;
  isTerminalArchived: boolean;
  constructor(
    private _router: Router,
    private route: ActivatedRoute,
    private _userDataStore: UserDataStoreService,
    private _authenticationService: AuthenticationService,
    private _modalService: NgbModal,
    private _terminalService: TerminalService,
    private _ngxUiLoaderService: NgxUiLoaderService,
    private _toastService: ToastrService,
    private _formBuilder: FormBuilder,
    private _merchantService: MerchantService,
    private _http: HttpClient,
    private _participantService: ParticipantService,
    private _modal: NgbActiveModal,
    private datePipe: DatePipe,
    private sanitizer: DomSanitizer) {

    route.params.pipe(takeUntil(this._destroyed$)).subscribe(async params => {
      

      this.merchantNumberId = params.merchantNumberId;
      this.terminalId = params.terminalId;
      this.type = params.type;
      if (params.data == 'Archived') {
        this.isTerminalArchived = true;
      }
      else {
        this.isTerminalArchived = false;
      }
      this.bulk = false;
    });
  }

  ngOnInit() {
    this.fcPowerSupply = "Yes";
    this.fcKeys = "Yes";
    this.fcParameterDownload = "Yes";
    this.fcBattery = "Yes";
    this.fcSoftwareVersion = '';
    this.fcAppName = '';
    this.fcTicketNr = '';
    this.Waybill = "";
    this.CustomerName = "";
    this.MerchantName = "";
    this.CreatedDate = "";
    this.TicketNo = "";
    this.MerchantNumber = "";
    this.ContactDetails = "";
    this.TerminalID = "";
    this.DeliveryAddress = "";
    this.SerialNumber = "";
    this.Make = "";
    this.Model = "";
    this.Country = "";
    this.Region = "";
    this.City = "";
    this.Town = "";
    this.PowerSupply = "";
    this.SoftwareVersion = "";
    this.AppName = "";
    this.Keys = "";
    this.Battery = "";
    this.DriverName = "";
    this.CustomerDate = "";
    this.DriverDate = "";
    this.DeliveryMethod = "";
    this.qrCodeImageURL = "";
    this.qrCodeImage1URL = "";
    this.isCourier = false;
  }

  public async ngAfterViewInit() {

    this._ngxUiLoaderService.start();

    
    var firstDevice: TerminalSignUpViewModel;
    this.merchantId = this.merchantNumberId;
    this.terminalId = this.terminalId;
    if (this.type == 'bulk') {
      this.terminalsSignUp = await this._terminalService.GetBulkTerminalSignedUpByMerchant(this.merchantId);
      if (this.terminalsSignUp == null || this.terminalsSignUp?.length <= 0) {
        this.terminalsSignUp = await this._terminalService.GetBulkArchivedTerminalSignedUpByMerchant(this.merchantId);
      }
      firstDevice = this.terminalsSignUp[0];
    }
    else {
      this.terminalSignUp = await this._terminalService.GetTerminalSignedUpById(this.terminalId);
      if (this.terminalSignUp == null) {
        this.terminalSignUp = await this._terminalService.GetArchivedTerminalSignedUpById(this.terminalId);
      }
      firstDevice = this.terminalSignUp;
      this.terminalsSignUp.push(this.terminalSignUp);
    }
    this.merchantSignUp = await this._merchantService.GetMerchantSignedUp(this.merchantId);
    this.terminalMakeList = await this._terminalService.GetDeviceMakes();
    this.terminalModelList = await this._terminalService.GetDeviceModels();
    this.merchantDetails = await this._merchantService.GetMerchantDetails(this.merchantId);
    this.Town = this.merchantDetails?.town ?? "";
    this.participant = await this._participantService.GetParticipantById(this.merchantDetails?.participantId);
    this.tmCardAcceptor = await this._merchantService.GetTmCardAcceptor(this.merchantId);
    var nameLocation = this.decodeNameLocation(this.tmCardAcceptor.name_location);
    if (this.terminalsSignUp.length > 0) {
      this.CustomerName = (this.participant?.name == null ? "" : this.participant.name);

      if (this.type == 'bulk') {
        this.terminalContacts = await this._terminalService.GetTerminalContacts(firstDevice.terminalId);
        this.ContactDetails = this.terminalContacts?.cell;
        this.DeliveryAddress = this.terminalContacts?.address;
        this.City = this.terminalContacts?.city;
        this.Region = this.terminalContacts?.region;
        this.Country = nameLocation.country;
      }
      else {

        this.merchantContacts = await this._merchantService.GetContactDetails(this.merchantId, "" + this.participant?.id);//add
        this.terminalContacts = await this._terminalService.GetTerminalContacts(firstDevice.terminalId);
        this.ContactDetails = (this.merchantContacts != null ? this.merchantContacts.mobileNumber + "/" + this.merchantContacts?.workNumber : "");
        this.DeliveryAddress = this.terminalContacts?.address == null ? this.merchantDetails?.merchantStreetAddress : this.terminalContacts?.address;
        this.City = this.terminalContacts?.city == null ? nameLocation.city : this.terminalContacts?.city;
        this.Region = this.terminalContacts?.region == null ? nameLocation.region : this.terminalContacts?.region;
        this.Country = nameLocation.country;
      }

    }

    this.Waybill = firstDevice.wayBill;
    this.MerchantName = nameLocation.shopName;
    const date = new Date(firstDevice.inUseDate);
    const formattedDate = this.datePipe.transform(date, 'yyyy-MM-dd HH:mm:ss', 'local');
    this.CreatedDate = formattedDate;
    this._ngxUiLoaderService.stop();

    
    this.DeliveryMethod = firstDevice.deliveryMethod;
    if (this.DeliveryMethod == "Courier" && (firstDevice.wayBill != '' && firstDevice.wayBill != null)) {
      
      this.isCourier = true;

      this.byteArrayBarCode = await this._terminalService.GetBarCode(firstDevice.wayBill);
      this.byteArrayQRCode = await this._terminalService.GetQRCode(firstDevice.wayBill);

      var image1 = document.getElementById('imgBarCode') as HTMLImageElement;
      image1.src = "data:image/jpeg;base64," + this.byteArrayBarCode;

      var image2 = document.getElementById('imgQRCode') as HTMLImageElement;
      image2.src = "data:image/jpeg;base64," + this.byteArrayQRCode;

    }

  }


  renderQRCodeImage() {
    
    if (this.byteArrayBarCode) {
      const blob = new Blob([this.byteArrayBarCode], { type: 'image/png' });
      var reader = new FileReader();
      var imageUrl = "";
      reader.onload = () => {
        // Set the data URL to an image element
        
        this.UserPhoto = reader.result as string;
        imageUrl = reader.result as string;
        var image = document.getElementById('qrCodeImage1') as HTMLImageElement;
        image.src = imageUrl;
        this.qrCodeImageURL = imageUrl;

        let objectURL = imageUrl;
        this.qrCodeImage1URL = this.sanitizer.bypassSecurityTrustUrl(objectURL);

      };
      
      reader.readAsDataURL(blob);
    }
  }

  print(): void {

    this.updateView();

    setTimeout(() => {
      this.LoadPrint();
    }, 1000);

  }

  public LoadPrint() {
    document.getElementById("fcTicketNr").style.display = "none";
    document.getElementById("fcAppName").style.display = "none";
    document.getElementById("fcSoftwareVersion").style.display = "none";
    document.getElementById("fcPowerSupply").style.display = "none";
    document.getElementById("fcKeys").style.display = "none";
    document.getElementById("fcParameterDownload").style.display = "none";
    document.getElementById("fcBattery").style.display = "none";


    this.printContents = document.getElementById('content').innerHTML;
    this.popupWin = window.open('', '_blank', 'top=50,left=1,height=100%,width=auto');
    this.popupWin.document.open();
    this.popupWin.document.write(`
      <html>
        <head>
          <title>Print tab</title>
           <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css">
        </head>
        <body onload="window.print();window.close()">${this.printContents}</body>
      </html>`
    );
    this.popupWin.document.close();
  }

  public updateTicketNr(value: any) {

    this.fcTicketNr = value;
  }

  public updateAppName(value: any) {

    this.fcAppName = value;
  }

  public updateSoftwareVersion(value: any) {

    this.fcSoftwareVersion = value;
  }

  public updateParameterDownload(value: Event) {

    this.fcParameterDownload = value;
  }

  public updateDevicePowerSupply(value: Event) {

    this.fcPowerSupply = value;
  }

  public updateKeys(value: Event) {

    this.fcKeys = value;
  }

  public updateDeviceBattery(value: Event) {

    this.fcBattery = value;
  }

  public updateView() {

    this.TicketNo = this.fcTicketNr;
    this.AppName = this.fcAppName;
    this.SoftwareVersion = this.fcSoftwareVersion;
    this.PowerSupply = this.fcPowerSupply;
    this.Keys = this.fcKeys;
    this.ParameterDownload = this.fcParameterDownload;
    this.Battery = this.fcBattery;
  }


  public GetDeviceMake(id: string) {
    if (this.terminalMakeList != undefined && parseInt(id) >= 0) {
      const foundItem = this.terminalMakeList?.find(item => item.id === parseInt(id));
      return foundItem?.make;
    }
    return "";
  }

  public GetDeviceModel(id: any) {
    if (this.terminalMakeList != undefined && parseInt(id) >= 0) {
      const foundItem = this.terminalModelList?.find(item => item.id === parseInt(id));
      return foundItem?.model;
    }
    return "";
  }

  public decodeNameLocation(nameLocation: string): DecodedNameLocation {
    return {
      shopName: nameLocation.substring(0, 23).trim(),
      city: nameLocation.substring(23, 36).trim(),
      region: nameLocation.substring(36, 38).trim(),
      country: nameLocation.substring(38, 40).trim(),
    };
  }

  public close() {
    this._modal.close();
  }

}
